(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/cart-form
 * -----------------------------------------------------------------------------
 * @version 0.0.2
 * @overview Cart form progressive enhancements.
 * @copyright 2022 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("cart-form") === undefined) {
    class CartForm extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            this.addEventListener("update", this.update.bind(this), false);
            document.addEventListener("cart:updated", this.update.bind(this), false);
        }
        update() {
            this.loadingState(true);
            const activeLineItem = document.activeElement.closest("cart-item")?.dataset.cartItemKey;
            fetch(`${this.dataset.url}?section_id=${this.dataset.sectionId}`).then((response)=>response.text()).then((responseText)=>{
                const html = new DOMParser().parseFromString(responseText, "text/html");
                const destination = document.querySelector(this.localName);
                const source = html.querySelector(this.localName);
                if (!source || !destination) return error;
                destination.innerHTML = source.innerHTML;
                this.querySelector(`[data-cart-item-key="${activeLineItem}"]`)?.querySelector('[name="updates[]"]')?.focus();
                this.loadingState(false);
            }).catch((error1)=>this.errorHandler(error1));
        }
        loadingState(loading) {
            loading ? [
                this,
                document.documentElement
            ].forEach((target)=>target.classList.add("loading")) : [
                this,
                document.documentElement
            ].forEach((target)=>target.classList.remove("loading"));
        }
        errorHandler(error1) {
            this.loadingState(false);
            console.error("An error has occured", error1);
        }
    }
    customElements.define("cart-form", CartForm);
}



})();
